import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '@/redux/store'

interface IcaewModalsState {
  numStepsCompleted: number
}

const INITIAL_STATE: IcaewModalsState = {
  numStepsCompleted: 0,
}

const icaewModals = createSlice({
  name: 'icaewModals',
  initialState: INITIAL_STATE,
  reducers: {
    setNumStepsCompleted(
      state,
      action: PayloadAction<IcaewModalsState['numStepsCompleted']>,
    ) {
      state.numStepsCompleted = action.payload
    },
  },
})

export const selectIcaewModals = (state: RootState) => state.icaewModals

export const { setNumStepsCompleted } = icaewModals.actions

export const icaewModalsReducer = icaewModals.reducer
